/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-02-01 21:40:54
 */

interface DownloadConfig {
  path: string
  openFolderWhenDone: boolean
}

interface DesktopLib {
  isDesktop: boolean
  loginSuccess: () => void
  logoutSuccess: () => void
  openContact: (contactUrl: string) => void
  getDownloadConfig: () => Promise<DownloadConfig>
  chooseDownloadPath: () => Promise<string>
  updateDownloadConfig: (config: DownloadConfig) => Promise<string>
  clientInfo?: any
  uploadLogs: (params: any) => Promise<any>

  // 下载相关方法
  downloadCreateTask: (params: any) => Promise<any>
  downloadGetTasks: (groupID: string) => Promise<any>
  downloadPauseTask: (taskId: string) => Promise<any>
  downloadResumeTask: (taskId: string) => Promise<any>
  downloadCancelTask: (taskId: string, deleteFiles?: boolean) => Promise<any>
  downloadRedownloadTask: (taskId: string) => Promise<any>
  openFolder: (path: string) => Promise<any>

  // 下载事件监听
  onDownloadProgressUpdate: (callback: (event: any, data: any) => void) => void
  onDownloadCompleted: (callback: (event: any, data: any) => void) => void
  onDownloadNetworkError: (callback: (event: any, data: any) => void) => void
  onDownloadError: (callback: (event: any, data: any) => void) => void
  onDownloadProgress: (callback: (event: any, data: any) => void) => void

  // 清理监听器
  removeDownloadListeners: (channel: string) => void
}

const desktopLib: DesktopLib = {
  isDesktop: !!(window as any).todayCameraAPI,
  loginSuccess: () => (window as any)?.todayCameraAPI?.loginSuccess(),
  logoutSuccess: () => (window as any)?.todayCameraAPI?.logoutSuccess(),
  openContact: (contactUrl) =>
    (window as any).todayCameraAPI.openContact(contactUrl),
  getDownloadConfig: () => (window as any)?.todayCameraAPI.getDownloadConfig(),
  chooseDownloadPath: () =>
    (window as any)?.todayCameraAPI.chooseDownloadPath(),
  updateDownloadConfig: (config) =>
    (window as any)?.todayCameraAPI.updateDownloadConfig(config),
  clientInfo: (window as any)?.clientInfo,
  uploadLogs: (params) =>
    (window as any)?.todayCameraAPI?.['upload-logs']?.(params),

  // 下载相关方法实现
  downloadCreateTask: (params) =>
    (window as any)?.todayCameraAPI?.['download:create-task']?.(params),
  downloadGetTasks: (groupID) =>
    (window as any)?.todayCameraAPI?.['download:get-tasks']?.(groupID),
  downloadPauseTask: (taskId) =>
    (window as any)?.todayCameraAPI?.['download:pause-task']?.(taskId),
  downloadResumeTask: (taskId) =>
    (window as any)?.todayCameraAPI?.['download:resume-task']?.(taskId),
  downloadCancelTask: (taskId, deleteFiles) =>
    (window as any)?.todayCameraAPI?.['download:cancel-task']?.(
      taskId,
      deleteFiles
    ),
  downloadRedownloadTask: (taskId) =>
    (window as any)?.todayCameraAPI?.['download:redownload-task']?.(taskId),
  openFolder: (path) =>
    (window as any)?.todayCameraAPI?.['open-folder']?.(path),

  // 下载事件监听实现
  onDownloadProgressUpdate: (callback) =>
    (window as any)?.todayCameraAPI?.['download:progress-update']?.(callback),
  onDownloadCompleted: (callback) =>
    (window as any)?.todayCameraAPI?.['download:completed']?.(callback),
  onDownloadNetworkError: (callback) =>
    (window as any)?.todayCameraAPI?.['download:network-error']?.(callback),
  onDownloadError: (callback) =>
    (window as any)?.todayCameraAPI?.['download:error']?.(callback),
  onDownloadProgress: (callback) =>
    (window as any)?.todayCameraAPI?.['download:progress']?.(callback),

  // 清理监听器
  removeDownloadListeners: (channel) =>
    (window as any)?.todayCameraAPI?.removeListener?.(channel)
}

export default desktopLib
